export default {
  selectedIntrestState: state => state.selectedIntrest
}
